<script lang="ts">
  import { projectStore } from '$lib/state/project.svelte';
  import StepRow from './StepRow.svelte';

  const root = $derived(
    projectStore.pipeline.steps[projectStore.pipeline.root_id],
  );
</script>

<div class="tree">
  {#if root}
    <StepRow stepId={root.id} depth={0} />
  {/if}
</div>

<style>
  .tree {
    display: flex;
    flex-direction: column;
    gap: 1px;
  }
</style>
